export const featureFlags = {
  translationFeatureFlag: true,
};
